if (!customElements.get('monties-bundle-edit')) {
  customElements.define('monties-bundle-edit', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        const img = this.querySelector('[data-image="wallet"]');
        if (img) this.walletViewObserver?.observe(img);
        return;
      }
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.model = this.querySelector('[data-model]');
      this.buy = this.querySelector('[data-buy]');
      this.status = this.querySelector('[data-status]');
      this.cartLink = this.querySelector('[data-cart]');
      this.root = this.config.root.replace(/\/$/, '') + '/';
      this.money = value => new Intl.NumberFormat(this.config.locale, {style:'currency', currency:this.config.currency}).format(value / 100);
      this.querySelectorAll('[data-color]').forEach(label => {
        const value = label.dataset.color.toLowerCase();
        const colors = [['burgundy','#69313d'],['charcoal','#343333'],['zwart','#343333'],['silver','#bcbebd'],['zilver','#bcbebd'],['glacier','#c4dce2'],['ice blue','#c4dce2'],['deep blue','#263d54'],['orange','#c56c36'],['oranje','#c56c36'],['amalfi','#315d86'],['blauw','#315d86']];
        label.style.setProperty('--swatch', colors.find(([name]) => value.includes(name))?.[1] || '#8c8578');
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-kind], [data-model]')) return;
        this.status.textContent = '';
        this.render();
      });
      this.buy.addEventListener('click', () => this.add());
      this.render();
      this.walletViewObserver = new ResizeObserver(() => this.alignWallet());
      const walletImage = this.querySelector('[data-image="wallet"]');
      if (walletImage) this.walletViewObserver.observe(walletImage);
    }
    // Straighten the full-resolution alpha edges to a shared front-facing frame.
    // Preserve the original artwork; coordinates include each source's object-fit padding.
    alignWallet() {
      const img = this.querySelector('[data-image="wallet"]');
      if (!img) return;
      const views = {"1241466":[1.3131032923,0,-0.1527281641,-0.0000018507,1.391853756,-0.250485825,-0.0000504276,0,1],"1576290":[0.9988053463,0.0006746234,0.0057018677,-0.0000592192,1.0421497064,-0.023048404,-0.0016136033,0.0007188316,1],"1990698":[1.1173956436,-0.0011437949,-0.0185249139,0.0410581185,1.0844306028,-0.0466291037,0.0767359103,0.001871067,1],"3821799":[1.0147536102,0,-0.0019870122,0.0024085668,1.0104427952,-0.0016123886,0.0134644527,0,1],"4915904":[1.0713247069,-0.0000815978,-0.0101080525,0.0293431146,1.0411528884,-0.0163453792,0.0585453889,-0.0028432789,1],"5556183":[1.0870694266,-0.0030837521,-0.0158738542,0.0278896674,1.0726285078,-0.0459845409,0.0661968179,-0.0120298506,1],"5985563":[0.9943842828,0,0.0043310791,-0.0003316453,0.9953287665,-0.0031131507,-0.0090366578,0,1]};
      const file = new URL(img.src, location.origin).pathname.split('/').pop();
      const id = /^niche-designs-magsafe-wallet-(\d+)\.png$/.exec(file)?.[1];
      const h = views[id], w = img.clientWidth, height = img.clientHeight;
      if (!h || !w || !height) {
        img.style.removeProperty('transform');
        img.style.removeProperty('transform-origin');
        delete img.dataset.walletView;
        return;
      }
      const matrix = [h[0],h[3]*height/w,0,h[6]/w,h[1]*w/height,h[4],0,h[7]/height,0,0,1,0,h[2]*w,h[5]*height,0,1];
      img.style.transformOrigin = '0 0';
      img.style.transform = 'matrix3d(' + matrix.join(',') + ')';
      img.dataset.walletView = 'front-aligned-v3';
    }
    disconnectedCallback() {
      this.walletViewObserver?.disconnect();
    }
    selection(preview = false) {
      const design = this.querySelector('[data-kind="case"]:checked')?.value;
      const walletId = this.querySelector('[data-kind="wallet"]:checked')?.value;
      const model = this.model.value || (preview ? this.config.previewModel : '');
      return {
        case: this.config.case.variants.find(v => v.options[0] === design && v.options[1] === model),
        wallet: this.config.wallet.variants.find(v => String(v.id) === walletId)
      };
    }
    render() {
      const preview = this.selection(true), chosen = this.selection();
      const design = this.querySelector('[data-kind="case"]:checked')?.value || '';
      this.querySelector('[data-name="case"]').textContent = design;
      this.querySelector('[data-name="wallet"]').textContent = preview.wallet?.options[0] || '';
      ['case','wallet'].forEach(kind => {
        const variant = preview[kind], img = this.querySelector('[data-image="'+kind+'"]'), link = this.querySelector('[data-detail="'+kind+'"]');
        if (variant?.image) {
          const usePackshot = kind === 'case' && !this.model.value;
          const photo = usePackshot ? this.config.designPhotos?.[design] || variant.image : variant.image;
          const source = new URL(photo, location.origin).href;
          if (img.src !== source) {img.removeAttribute('srcset');img.src = source;}
          img.alt = usePackshot && this.config.designPhotos?.[design] ? design + ' — ' + this.config.previewModel : variant.title;
        }
        if (kind === 'wallet') this.alignWallet();
        link.href = this.config[kind].url + (variant ? '?variant=' + variant.id : '');
      });
      const caption = this.querySelector('[data-model-caption]');
      if (caption) caption.textContent = preview.case ? preview.case.options[0] + ' · ' + preview.case.options[1] : '';
      this.querySelectorAll('[data-kind="case"]').forEach(input => {
        const matching = this.config.case.variants.filter(v => v.options[0] === input.value && (!this.model.value || v.options[1] === this.model.value));
        input.disabled = Boolean(this.busy || !matching.some(v => v.available));
      });
      this.querySelectorAll('[data-kind="wallet"]').forEach(input => {
        input.disabled = Boolean(this.busy || !this.config.wallet.variants.find(v => String(v.id) === input.value)?.available);
      });
      this.model.disabled = Boolean(this.busy);
      const sum = (preview.case?.price || 0) + (preview.wallet?.price || 0);
      const saving = sum - this.config.bundlePrice;
      this.querySelector('[data-price]').textContent = this.money(this.config.bundlePrice);
      this.querySelector('[data-original]').textContent = this.money(sum);
      this.querySelector('[data-original]').hidden = saving <= 0;
      this.querySelector('[data-saving]').textContent = saving > 0 ? this.config.text.save + ' ' + this.money(saving) : '';
      this.valid = Boolean(chosen.case?.available && chosen.wallet?.available && this.config.bundleAvailable);
      this.buy.disabled = Boolean(this.busy || this.uncertain || this.added || !this.valid);
      this.buy.textContent = this.busy ? this.config.text.busy : !this.model.value ? this.config.text.chooseModel : !this.valid ? this.config.text.unavailable : this.config.text.add;
    }
    async readProduct(handle) {
      const response = await fetch(this.root+'products/'+encodeURIComponent(handle)+'.js', {headers:{Accept:'application/json'},cache:'no-store'});
      if (!response.ok) throw new Error(this.config.text.error);
      return response.json();
    }
    async add() {
      if (this.buy.disabled || !this.valid) return;
      const selected = this.selection();
      this.busy = true;
      this.status.textContent = '';
      this.cartLink.hidden = true;
      this.render();
      let sent = false;
      try {
        const [caseProduct,walletProduct,bundle] = await Promise.all([this.readProduct(this.config.case.handle),this.readProduct(this.config.wallet.handle),this.readProduct(this.config.bundleHandle)]);
        const fresh = [caseProduct,walletProduct].map((p,i) => p.variants.find(v => v.id === selected[i ? 'wallet' : 'case'].id));
        if (!fresh.every(v => v?.available) || !bundle.available) throw new Error(this.config.text.unavailable);
        if (fresh[0].price !== selected.case.price || fresh[1].price !== selected.wallet.price || bundle.price !== this.config.bundlePrice) {
          this.config.case.variants.find(v => v.id === selected.case.id).price = fresh[0].price;
          this.config.wallet.variants.find(v => v.id === selected.wallet.id).price = fresh[1].price;
          this.config.bundlePrice = bundle.price;
          throw new Error(this.config.text.changed);
        }
        const stamp = String(Date.now());
        const items = ['case','wallet'].map(kind => ({id:selected[kind].id,quantity:1,properties:{__fbBundleClick:this.config.bundleId+':'+this.config[kind+'ItemId']+':'+stamp}}));
        sent = true;
        const response = await fetch(this.root+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const added = await response.json();
        if (!response.ok) {
          sent = false;
          throw new Error(typeof added.description === 'string' ? added.description : this.config.text.error);
        }
        this.added = true;
        this.status.textContent = this.config.text.success;
        this.cartLink.hidden = false;
        window.location.assign(this.root+'cart');
      } catch (error) {
        this.status.textContent = sent ? this.config.text.unknown : error.message || this.config.text.error;
        this.cartLink.hidden = !sent;
        this.uncertain = sent;
      } finally {
        this.busy = false;
        this.render();
      }
    }
  });
}
